/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";

import { TabPanel, TabView } from "primereact/tabview";

// Dashboard components
import MDBox from "components/MDBox";

// Dashboard example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// @mui material components
import Grid from "@mui/material/Grid";

import { getSubModulesByRoleId } from "../../store";

import Cookies from "universal-cookie";

import PoListing from "layouts/po-management/po-listing";
import CompletedPo from "./completed-po";
import PoProcessLog from "./po-process-log";

const cookies = new Cookies();

const PoManagement = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let poListingModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "269a9257-c102-4b7a-9894-cebaf12a363c",
  );

  let PoProcessLogModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "d629b84f-74e2-43b9-9701-9f6cb3872ba5",
  );

  let completedPoModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "44399f88-242f-4f3f-983f-8f25360c2804",
  );

  // Build tabs dynamically based on access
  const tabs = [];

  // Wo Listing tab
  if (poListingModule) {
    tabs.push({
      header: "Wo Listing",
      content: <PoListing />,
    });
  }

  // Wo Process Log tab
  if (PoProcessLogModule) {
    tabs.push({
      header: "Wo Process Log",
      content: <PoProcessLog />,
    });
  }

  // Wo Process Log tab
  if (completedPoModule) {
    tabs.push({
      header: "Completed Wo",
      content: <CompletedPo />,
    });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            {tabs.length > 0 ? (
              <TabView>
                {tabs.map((tab, idx) => (
                  <TabPanel key={idx} header={tab.header}>
                    {tab.content}
                  </TabPanel>
                ))}
              </TabView>
            ) : (
              <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                No Access
              </h4>
            )}
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(PoManagement);
